import {useCallback} from 'react';
import {useHistory} from 'react-router-dom';
import {ApolloError} from '@apollo/client';

// Types
import {LoginUserMutation, ProfileFieldsFragment, ProfileTypeEnum} from '~graphqlResources';
// Config
import {enterpriseProfileRoute, talentProfileRoute} from '~config/routes';
import {dashboardMarketingRoute} from '~config/routes/marketingPortal';
// Hooks
import useOnGraphQLError from '~hooks/useOnGraphQLErrors';



function useAuthCallbacks() {
    const history = useHistory();
    const handleGraphQLError = useOnGraphQLError();

    const redirectByProfileType = useCallback((profile: ProfileFieldsFragment) => {
        if (profile.type?.toLowerCase() === ProfileTypeEnum.TALENT.toLowerCase()) {
            history.replace(talentProfileRoute);
        } else if (profile.type?.toLowerCase() === ProfileTypeEnum.ENTERPRISE.toLowerCase()) {
            history.replace(enterpriseProfileRoute);
        } else if (profile.type?.toLowerCase() === 'ADMIN'.toLowerCase()) {
            history.replace(dashboardMarketingRoute);
        }
    }, [history]);

    const onLoginSuccess = useCallback((response: LoginUserMutation['login']) => {
        if (response?.profile) {
            redirectByProfileType(response.profile);
        } else {
            // eslint-disable-next-line no-console
            console.warn('Can\'t determine type of user');
        }
    }, [redirectByProfileType]);

    const onSocialLoginError = useCallback(
        (err: ApolloError) => handleGraphQLError()(err),
        [handleGraphQLError]
    );

    return {onLoginSuccess, onSocialLoginError, redirectByProfileType};
}

export default useAuthCallbacks;
